
function focus_the_game() {
	window.focus();
}

function get_game_size() {

	return {
		width: 64,
		height: 64
	};

}

function set_game_size() {
	var size = get_game_size();
	game.scale.setGameSize( size.width, size.height );
}

var Game = {

	// Game Properties.
	name: 'Star Raid',
	debug: false,
	background_color: '#006d99',
	desiredFps: false,

	//
	font_set: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789.,;:?!-_\'#"\\/<>()@',
	game_state: 'play',

	// Code collections.
	States: {},
	Prefabs: {},
	Utils: {},
	Plugins: {},
	JSON: {},

};
